































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ChartsViewModel, ChartsService } from '../../api/charts';
@Component({})
export default class ChartsList extends Vue {
  @Prop()
  private condition!: ChartsViewModel;

  private service: ChartsService = new ChartsService();
  private data: any = [];

  private pageIndex: number = 1;

  private mounted() {
    this.Search(this.condition, 1);
  }
  @Emit()
  private OnLoaded(totalCount: number) {
    return totalCount;
  }
  private Search(condition: ChartsViewModel, pageIndex: number) {
    this.pageIndex = pageIndex;
    this.condition = condition;
    this.service.Search(condition, pageIndex).then((response: any) => {
      this.data = response;
      this.OnLoaded(response.totalCount);
    });
  }
  private page_OnChange(page: number) {
    this.Search(this.condition, page);
  }
  private thumb_OnClick(item: any) {
    this.$router.push({name: 'ChartsDetail', query: {id: item.id}});
  }
}
